import React from 'react';
import {Block, Title} from '../../../../components/components'
import { useTranslation } from 'react-i18next';
import Table from "../../../../components/tables/Table";
import useCustomTable from "../../../../components/tables/useCustomTable";
import {useHistory} from "react-router-dom";
import FormButton from "../../../../components/forms/FormButton";
import {useGetUsersQuery} from "../../../../api/userApiSlice";
import {TableSearchRow} from "../../../../components/tables/TableSearch";
import Pagination from "../../../../components/tables/Pagination";
import { Loader } from '../../../../components/components';

function Users() {
	const { t } = useTranslation();
  const history = useHistory();
  const {data: users = [], isSuccess, isLoading} = useGetUsersQuery()

  const usersColumns = [{
    Header: t('users.firstName'),
    accessor: 'firstName',
  },{
    Header: t('users.lastName'),
    accessor: 'lastName',
  },{
    Header: 'Email',
    accessor: 'email',
  },{
    Header: t('users.createdAt'),
    accessor: 'createdAt',
    format: 'date',
  },{
    Header: t('users.lastConnection'),
    accessor: 'currentSignInAt',
    format: 'date',
  }];

	const tableOptions = {
		sortable: true,
		filterable: true,
		paginate: true
	}

  const {
    tableProps,
    paginationProps,
    tableSearchProps
  } = useCustomTable()

  const showUser = function(user) {
    history.push(`users/${user.slug}`);
  }

	return (
		<>
      <Title main={t("menu.users")}>
        <FormButton new />
      </Title>
      <TableSearchRow {...tableSearchProps}/>
      <Block className="mb-0">
        <Loader success={!isLoading && isSuccess} error={!isLoading && !isSuccess}>
          <Table data={users} columns={usersColumns} onRowClick={showUser} {...tableOptions} {...tableProps}/>
        </Loader>
      </Block>
      <Pagination {...paginationProps}/>
		</>
	)
}

export default Users
